import { useState, useEffect } from "react";

import config from "../config"

const useManagerAPI = (controller, method, doFetch, data, accessToken) => {
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(false)
	
  //const accessToken = sessionStorage.getItem(config.storageKey.accessToken) || ''
	
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer "+accessToken
    },
    credentials: 'include',
    body: JSON.stringify(data)
  };

  const url = config.api.manager.url+"/"+controller+"/"+method

  useEffect(() => {
    setLoading(doFetch)
    if (doFetch) {
      setResponse(null)
      fetch(url, options)
        .then((response) => response.json())
        .then((data) => setResponse(data))
        .catch((error) => console.error("Error:", error))
        .finally(() => setLoading(false))
    }
  }, [doFetch]);

  return {response:response, loading:loading}
}

export default useManagerAPI